/**
 *
 */
export function mobileMenu() {

	const hamburger = document.querySelector( '#navigation-toggle' )
	const pageHeader = document.querySelector( '.page-header' );

	hamburger.addEventListener( 'change', function handleHamburgerClick() {

		if ( hamburger.checked ) {

			pageHeader.classList.add( 'page-header__navigation-toggle-checked' );
			document.documentElement.style.overflowY = 'hidden';

		} else {

			pageHeader.classList.remove( 'page-header__navigation-toggle-checked' );
			document.documentElement.style.overflowY = 'scroll';

		}

	} );

	window.addEventListener( 'resize', function handleWindowResize() {

		if ( window.innerWidth > 1179 ) {

			document.documentElement.style.overflowY = 'scroll';

		} else if ( hamburger.checked ) {

			document.documentElement.style.overflowY = 'hidden';

		}

	} );

}

/**
 *
 */
export function initializeMobileMenuHeight() {

	/**
	 *
	 */
	function mobileMenuHeight() {

		const hDetectWindow = window.innerHeight;
		const hDetectHBlack = document.querySelector( '.mobile-navigation__height' ).offsetHeight;
		const min = hDetectWindow;
		const max = hDetectHBlack;
		let bar;
		let hDetectAct;

		if ( window.innerHeight < max ) {

			bar = 'show';

		} else {

			bar = 'hide';

		}

		if ( bar === 'show' ) {

			hDetectAct = min;

		}

		if ( bar === 'hide' ) {

			hDetectAct = document.querySelector( '.mobile-navigation__height' ).offsetHeight;

		}

		if ( window.innerWidth < 1180 ) {

			document.querySelector( '.page-header__navigation' ).style.height = `calc(${ hDetectAct }px - 88px)`;

		} else {

			document.querySelector( '.page-header__navigation' ).style.height = `unset`;

		}

	}

	mobileMenuHeight();

	window.addEventListener( 'resize', () => {

		mobileMenuHeight();

	} );

}
